import React, { ReactNode } from "react";
import { joinStrings } from "../../../utils/misc";
import styles from "./PageContainer.module.scss";

interface PageContainerProps {
  children?: ReactNode;
  className?: string;
}

function PageContainer(props: PageContainerProps) {
  const { children, className } = props;

  const rootClassName = joinStrings(styles.root, className);

  return <div className={rootClassName}>{children}</div>;
}

export default PageContainer;
